var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9998C0 7.16337 7.16337 0 15.9998 0C24.8363 0 31.9997 7.16337 31.9997 15.9998C31.9997 24.8363 24.8363 31.9997 15.9998 31.9997C7.16337 31.9997 0 24.8363 0 15.9998Z",
    fill: "rgb(2, 131, 131)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2729 15.2812C22.3922 15.2285 22.4935 15.142 22.5642 15.0324C22.6348 14.9228 22.6718 14.7948 22.6704 14.6644C22.6691 14.5339 22.6295 14.4068 22.5566 14.2986C22.4837 14.1904 22.3806 14.106 22.2602 14.0559L16.5463 11.4532C16.3726 11.374 16.1839 11.333 15.9929 11.333C15.802 11.333 15.6133 11.374 15.4396 11.4532L9.72636 14.0532C9.60767 14.1052 9.5067 14.1906 9.43581 14.2991C9.36491 14.4075 9.32715 14.5343 9.32715 14.6639C9.32715 14.7934 9.36491 14.9202 9.43581 15.0287C9.5067 15.1371 9.60767 15.2225 9.72636 15.2745L15.4396 17.8798C15.6133 17.9591 15.802 18.0001 15.9929 18.0001C16.1839 18.0001 16.3726 17.9591 16.5463 17.8798L22.2729 15.2812Z",
    stroke: "white",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6592 14.6665V18.6665",
    stroke: "white",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9932 16.3333V18.6666C11.9932 19.197 12.4146 19.7057 13.1647 20.0808C13.9149 20.4558 14.9323 20.6665 15.9931 20.6665C17.054 20.6665 18.0714 20.4558 18.8215 20.0808C19.5716 19.7057 19.9931 19.197 19.9931 18.6666V16.3333",
    stroke: "white",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9998,
    height: 15.9998,
    fill: "white",
    transform: "translate(7.99316 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationnew);
export default __webpack_public_path__ + "static/media/Educationnew.21053955471e1ccfb35db9d7686898ef.svg";
export { ForwardRef as ReactComponent };